import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Loads CMS-managed settings for a given page slug.
 * Falls back to the provided defaults until the network request resolves
 * (or if it fails) so pages never flash empty content.
 */
export function usePageSettings(slug, defaults = {}) {
  const [settings, setSettings] = useState({ ...defaults, slug });
  const [loaded, setLoaded] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/site-pages/${slug}`)
      .then((res) => {
        if (cancelled) return;
        // Treat empty strings as "use default" so admins can clear a field.
        const merged = { ...defaults };
        Object.entries(res.data || {}).forEach(([k, v]) => {
          if (v !== undefined && v !== null) merged[k] = v;
        });
        setSettings({ ...merged, slug });
      })
      .catch((err) => {
        // Backend returns 404 when admin has hidden the page.
        if (err?.response?.status === 404 && !cancelled) {
          setHidden(true);
        }
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return { settings, loaded, hidden };
}
